module.exports = __webpack_public_path__ + "img/sport_equipment.5ebaebc7.png";